/**
 * @typedef {string} BSBSixDigit
 * A 6 digit representation of the BSB.
 */
/**
 * @typedef {string} BSBMnemonic
 * The mnemonic for the BSB's financial institution.
 */
/**
 * @typedef {string} BSBName
 * The name of the BSB.
 */
/**
 * @typedef {[ BSBSixDigit, BSBMnemonic, BSBName ]} BSBEntry
 * A 3 element Tuple containing the six digit BSB, bank mnemonic, and bsb name
 */

/**
 * @return {Array<BSBEntry>}
 */
function getNodeAusPaymentsNetworkBsbs() {
  return [];
}

/**
 * @return {Array<BSBEntry>}
 */
function getBrowserAusPaymentsNetworkBsbs() {
  return window.AusPayNetBsbs || [];
}

export function getAusPaymentsNetworkBsbs() {
  return typeof window === "undefined"
    ? getNodeAusPaymentsNetworkBsbs()
    : getBrowserAusPaymentsNetworkBsbs();
}
